export const NotFoundScreen = () => {
    return (
        <h1>Not Found Screen</h1>
    );
}